import {Get, Post} from "../axios.config";

/** @author ljj 2020.09.11
 * 名称: 端外-会员商品列表
 * 
 * yapi: 
 *
 *  参数                          类型      是否必须    备注
 * */

export default function v1_vip_membergood_detail(data) {
    let url         = 'v1/vip/member_good/detail';
    let yapimockurl = '';

    return Get({url, yapimockurl, data});
}


// WEBPACK FOOTER //
// ./src/api/name/v1_vip_membergood_detail.api.js